import { createContext, useContext } from 'react'
import type { WebApp } from '@twa-dev/types'

/**
 * Контекст для Telegram Web App SDK
 * 
 * Размещен в shared/lib/telegram, так как используется в shared/lib/telegram/use-telegram.ts
 * Provider находится в app/telegram-provider.tsx
 */
export interface TelegramContextType {
  webApp: WebApp
  initData: string
  isVk: boolean
  vkUserInfo: any
}

export const TelegramContext = createContext<TelegramContextType | null>(null)

/**
 * Хук для использования Telegram контекста
 * 
 * Возвращает контекст Telegram Web App SDK. Должен использоваться только
 * внутри компонентов, обернутых в TelegramProvider.
 * 
 * Используется внутри shared/lib/telegram/use-telegram.ts для получения
 * webApp и initData из контекста.
 * 
 * @returns Объект с webApp и initData
 * @throws {Error} Выбрасывает ошибку если используется вне TelegramProvider
 * 
 * @example
 * ```tsx
 * function MyComponent() {
 *   const { webApp, initData } = useTelegramContext()
 *   // Использование webApp и initData
 * }
 * ```
 */
export function useTelegramContext() {
  const context = useContext(TelegramContext)
  if (!context) {
    throw new Error('useTelegramContext must be used within TelegramProvider')
  }
  return context
}

